import { useRouter } from 'next/router';
import { useEffect } from 'react'
import { useSearchBox } from 'react-instantsearch';
import useOnClickOutside from '../useOnClickOutside';

const useAlgoliaSearchInput = (setIsSearching, ourSearchContainer, ourSearchInput, ourSearchButton, setQuery, inputValue, setInputValue) => {
  const {events} = useRouter()
  const { refine } = useSearchBox();

  useEffect(() => {

    events.on('routeChangeComplete', () => {
      setIsSearching(false)
      setQuery("", setInputValue, refine)
    })
  }, [events, refine, setInputValue, setIsSearching, setQuery])

  useOnClickOutside([ourSearchContainer, ourSearchInput, ourSearchButton], () => {
    setIsSearching(false);
    setQuery("", setInputValue, refine);
  })

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      const fetchProductsBySearchWord = () => {

        if (inputValue && inputValue != undefined) {
          setQuery(inputValue, setInputValue, refine)
          setIsSearching(true);
        } else {
          setIsSearching(false);
          setQuery("", setInputValue, refine); 
        }
      }
      fetchProductsBySearchWord()
    }, 50)

    return () => clearTimeout(debounceTimeout)
  }, [inputValue, refine, setInputValue, setIsSearching, setQuery])

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check if the pressed key is the Esc key (key code 27)
      if (event.key === 'Escape' || event.keyCode === 27) {
        setQuery('');
      }
    };

    // Add event listener when component mounts
    document.addEventListener('keydown', handleKeyDown);

    // Remove event listener when component unmounts
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [setQuery]);

  useEffect(() => {
    inputValue ? setIsSearching(true) : setIsSearching(false)
  }, [inputValue, setIsSearching])

  return {
    setQuery,
    inputValue,
    setInputValue
  }
}

export default useAlgoliaSearchInput